import React, { useCallback, useEffect } from 'react';
import { StyleSheet } from 'react-native';
import { Container } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { getUserConfig, updateUserConfig } from '../../redux/configuration/action';
import { userConfigurationSelector } from '../EsSettings/selector';
import { AccountCommunications as AccountCommunicationsComponent } from '../../components/AccountSettings';

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
});

const AccountCommunications = () => {
    const configuration = useSelector(userConfigurationSelector);
    const dispatch = useDispatch();
    const handleUpdatePreference = (payload: any) => {
        dispatch(
            updateUserConfig({
                payload,
            }),
        );
    };
    const handlegetUserPreference = useCallback(() => {
        dispatch(getUserConfig());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        handlegetUserPreference();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Container disableGutters style={styles.container} maxWidth={false}>
            <AccountCommunicationsComponent
                onChange={payload => handleUpdatePreference(payload)}
                setting={configuration}
            />
        </Container>
    );
};

export { AccountCommunications };
